import { Component, inject } from '@angular/core';
import { Params } from '@angular/router';
import { map } from 'rxjs';
import { BreadcrumbService } from 'xng-breadcrumb';
import { BreadcrumbInfo } from '../../models/breadcrumb-info.model';

interface AppBreadcrumbItem {
  routeLink?: string;
  label: string;
  info?: BreadcrumbInfo;
  disable?: boolean;
  queryParams?: Params;
  fragment?: string;
}

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './app-breadcrumb.component.html',
  styleUrls: ['./app-breadcrumb.component.scss'],
  standalone: false,
})
export class AppBreadcrumbComponent {
  readonly breadcrumbs$ = inject(BreadcrumbService).breadcrumbs$.pipe(
    map((breadcrumbs) =>
      breadcrumbs.map((breadcrumb) =>
        this.toBreadcrumbItem({
          ...breadcrumb,
          routeLink:
            breadcrumb.routeInterceptor?.(breadcrumb.routeLink ?? '', breadcrumb) ||
            breadcrumb.routeLink,
        })
      )
    )
  );

  private toBreadcrumbItem(breadcrumb: {
    routeLink?: string;
    label?: string | ((resolvedLabel?: string) => string);
    info?: unknown;
    disable?: boolean;
    queryParams?: unknown;
    fragment?: string;
  }): AppBreadcrumbItem {
    const label = typeof breadcrumb.label === 'function' ? '' : breadcrumb.label;

    return {
      routeLink: breadcrumb.routeLink,
      label: label ?? '',
      info: breadcrumb.info as BreadcrumbInfo | undefined,
      disable: breadcrumb.disable,
      queryParams: breadcrumb.queryParams as Params | undefined,
      fragment: breadcrumb.fragment,
    };
  }
}
